import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { FormsUtil, MbsPopupType, ModalComponent, ToastService } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { Destination, StorageAccountV2 } from 'mbs-ui-shared/src/lib/models/StorageAccount';
import { StorageAccountsService } from 'mbs-ui-shared@services/storage-accounts/storage-accounts.service';
import { finalize } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mbs-add-ftp-root-folder-modal',
  templateUrl: './add-destination-alternate-modal.component.html'
})
export class AddDestinationAlternateModalComponent implements OnInit {
  public readonly popupType = MbsPopupType;
  public readonly storageType = StorageType;

  public storageAccount: StorageAccountV2;
  public destination: Destination;
  public form = this.fb.group({
    displayBucketName: new FormControl('', [Validators.required]),
    bucketName: new FormControl('', [Validators.required]),
    companies: new FormControl([])
  });
  public errorText = null;
  public loading = false;
  public rootFolderName: string;
  public selectedCompanyIds = [];
  public finalSuccessAction: () => void;

  @ViewChild(ModalComponent, { static: true }) modal: ModalComponent;

  constructor(
    private fb: FormBuilder,
    private storageAccountService: StorageAccountsService,
    private i18N: I18NextPipe,
    private toast: ToastService
  ) {}

  ngOnInit() {
    this.rootFolderName =
      this.storageAccount.storageType === StorageType.LocalFS
        ? this.i18N.transform('shared:common.path')
        : this.i18N.transform('shared:common.rootFolder');

    if (this?.destination?.isReadOnly) {
      return void this.form.disable();
    }

    if (this.destination) {
      this.selectedCompanyIds = this.destination?.assignedCompanies || [];
      this.form.patchValue({
        displayBucketName: this.destination.displayName,
        bucketName: this.destination?.bucket?.bucketName
      });
    }
  }

  private handleFinalSuccess() {
    this.toast.success(this.i18N.transform('shared:modals.addDestinationBucket.destinationSaved'));
    this.finalSuccessAction && this.finalSuccessAction();
  }

  onActionButtonClick() {
    if (!this.form.valid) {
      return void FormsUtil.triggerValidation(this.form);
    }

    this.loading = true;
    const { displayBucketName, bucketName, companies } = this.form.value;
    const data = {
      displayBucketName,
      bucket: {
        bucketName
      },
      assignToCompanies: companies.map((company) => company.id)
    };

    const query$ = this.destination
      ? this.storageAccountService.editDestination({
          storageAccountId: this.storageAccount?.id,
          data,
          destinationId: this.destination?.id,
          skipError: true
        })
      : this.storageAccountService.createDestination({
          storageAccountId: this.storageAccount?.id,
          data,
          skipError: true
        });

    query$.pipe(finalize(() => (this.loading = false))).subscribe({
      next: () => {
        this.handleFinalSuccess();
        this.modal.save();
      },
      error: (err) => (this.errorText = err?.error?.detail)
    });
  }
}
